import save from './save';
import createSiteBackup from './create-site-backup';
import restoreSiteBackup from './restore-site-backup';
import fetchSiteBackups from './fetch-site-backups';
import deleteSiteBackup from './delete-site-backup';

export default {
  save,
  createSiteBackup,
  restoreSiteBackup,
  fetchSiteBackups,
  deleteSiteBackup,
};
